import { ParallaxImage } from "@/components/parallax-image";
import { Reveal } from "@/components/reveal";
import { BUSINESS } from "@/lib/site-data";

export function CtaBand() {
  return (
    <section className="night content-auto relative isolate overflow-hidden py-24">
      <ParallaxImage
        name="frame-selection"
        alt=""
        speed={0.25}
        className="absolute inset-0 -z-10"
        imgClassName="opacity-20"
      />
      <div className="shell text-center">
        <Reveal>
          <p className="eyebrow-light">By appointment</p>
          <h2 className="display mx-auto mt-5 max-w-2xl text-4xl sm:text-5xl lg:text-6xl">
            Bring it in. We'll design it together.
          </h2>
          <a
            href={BUSINESS.phoneHref}
            className="display mt-8 inline-block text-5xl text-[var(--amber-warm)] transition-opacity duration-500 hover:opacity-75 sm:text-6xl"
          >
            {BUSINESS.phone}
          </a>
          <p className="mt-5 text-sm text-muted-foreground">
            {BUSINESS.address} · Most days and times, including after hours.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
